/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { applyCreateDraftResult } from './helpers/applyCreateDraftResult';
import { findListingEntity } from './helpers/entityReadHelpers';
import refreshListingAssetsForChannels from './helpers/refreshListingAssetsForChannels';
import { setSelectedChannelByProduct } from './helpers/uiAdapter';

export const createProductDraftFromLive = createAsyncThunk(
  'products/createProductDraftFromLive',
  async ({ productId, channelId }, { dispatch, getState, extra: { sdk } }) => {
    const productsState = getState().products;
    const listing = findListingEntity(productsState, { masterProductId: productId, channelId });
    const listingProductId = listing?._id;
    const live = listing?.live;

    if (!listingProductId || !live) {
      throw new Error('Live product not found');
    }

    const { data } = await sdk.products.createDraft(listingProductId, {
      source: 'live',
      copyLiveAssets: true,
    });

    await refreshListingAssetsForChannels({
      dispatch,
      getState,
      productId,
      channelIds: [channelId],
    });

    return {
      productId,
      channelId,
      listing: data.listing,
      variants: data.variants || [],
    };
  },
);

export const reducer = (builder) => {
  builder
    .addCase(createProductDraftFromLive.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(createProductDraftFromLive.fulfilled, (state, { payload }) => {
      const {
        productId, channelId, listing, variants,
      } = payload;

      state.isBusy = false;

      applyCreateDraftResult(state, {
        productId,
        channelId,
        listing,
        variants,
      });

      setSelectedChannelByProduct(state, productId, channelId);
    })
    .addCase(createProductDraftFromLive.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot create staging from live';
    });
};
